// Centralised brand quote library — never alter wording without approval.
export const QUOTES = {
    primary: "My life began when they told me it was over.",
    invitation: "Begin from where you are.",
    transformation:
        "She did not wait until she felt completely healed, fearless or ready. She began building from where she was. Perhaps I can begin from where I am too.",
    transformationFirstPerson:
        "I did not wait until I felt completely healed, fearless or ready. I began building from where I was. Perhaps you can begin from where you are too.",
    cancerBeginning: "Cancer should never be the reason you stop. It can become the reason you start.",
    survivalIdentity: "Surviving kept me here. Finding my voice made me feel alive again.",
    bodyWorth: "Your body may change. Your worth does not.",
    adversity: "Adversity can interrupt your life without being allowed to define the rest of it.",
    story: "What tried to end my story became the beginning of another one.",
    survival: "Surviving and feeling alive are not always the same thing.",
    readerInvitation: "Perhaps your story is not finished either.",
    building: "I am turning lived experience into something useful.",
    ventures:
        "These are not businesses attached to my story. They are what I built because of what the story taught me.",
    aliveLiving: "Being alive and living are not the same thing.",
    father: "My father reminded me who I was.",
};
